import { render } from "./GreatGrandfather.vue?vue&type=template&id=91780120"
import script from "./GreatGrandfather.vue?vue&type=script&lang=js"
export * from "./GreatGrandfather.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__